import { Howl, Howler } from 'howler';

export class AudioPlayer {
	private static instance: AudioPlayer;

	public voiceOvers = {
		opening: new Howl({
			src: '../static/audio/01-voiceover.mp3',
			preload: false,
		}),
		waterFaucet: new Howl({
			src: '../static/audio/02-voiceover.mp3',
			preload: false,
		}),
		lightSwitch: new Howl({
			src: '../static/audio/03-voiceover.mp3',
			preload: false,
		}),
		transport: new Howl({
			src: '../static/audio/04-voiceover.mp3',
			preload: false,
		}),
		final: new Howl({
			src: '../static/audio/05-voiceover.mp3',
			preload: false,
		}),
	};

	public soundFx = {
		general: {
			actionChime: new Howl({
				src: '../static/audio/action-chime.mp3',
				preload: false,
				volume: 0.1,
			}),
			correctActionChime: new Howl({
				src: '../static/audio/correct-action.mp3',
				preload: false,
				volume: 0.1,
			}),
			wrongActionChime: new Howl({
				src: '../static/audio/wrong-action.mp3',
				preload: false,
				volume: 0.1,
			}),
		},
		waterFaucetScene: {
			runningWater: new Howl({
				src: '../static/audio/water-faucet-scene/running-water.mp3',
				preload: false,
				volume: 0.1,
			}),
			waterDraining: new Howl({
				src: '../static/audio/water-faucet-scene/water-draining.mp3',
				preload: false,
				volume: 0.1,
			}),
			underwaterAmbience: new Howl({
				src: '../static/audio/water-faucet-scene/underwater-ambience.mp3',
				preload: false,
				volume: 0.1,
			}),
			waterSplashing: new Howl({
				src: '../static/audio/water-faucet-scene/water-splashing.mp3',
				preload: false,
				volume: 0.1,
			}),
			faucetSqueak: new Howl({
				src: '../static/audio/water-faucet-scene/faucet-squeak.mp3',
				preload: false,
				volume: 0.1,
			}),
		},
		lightSwitchScene: {
			energyDrone: new Howl({
				src: '../static/audio/light-switch-scene/energy-drone.mp3',
				preload: false,
				volume: 0.3,
			}),
			lightSwitchOff: new Howl({
				src: '../static/audio/light-switch-scene/light-switch-off.mp3',
				preload: false,
				volume: 0.3,
			}),
			doorOpening: new Howl({
				src: '../static/audio/light-switch-scene/door-opening.mp3',
				preload: false,
				volume: 0.1,
			}),
		},
		transportScene: {
			biycleNoise: new Howl({
				src: '../static/audio/transport-scene/bicycle-noise.mp3',
				preload: false,
				volume: 0.2,
			}),
			bikePedals: new Howl({
				src: '../static/audio/transport-scene/bike-pedals.mp3',
				preload: false,
				volume: 0.2,
			}),
			birdsChirping: new Howl({
				src: '../static/audio/transport-scene/birds-chirping.mp3',
				preload: false,
				volume: 0.2,
			}),
			carIdling: new Howl({
				src: '../static/audio/transport-scene/car-idle.mp3',
				preload: false,
				volume: 0.1,
			}),
			carRollout: new Howl({
				src: '../static/audio/transport-scene/car-rollout.mp3',
				preload: false,
				volume: 0.1,
			}),
			sheep: new Howl({
				src: '../static/audio/transport-scene/sheep-baah.mp3',
				preload: false,
				volume: 0.1,
			}),
		},
		finalScene: {
			brightDrone: new Howl({
				src: '../static/audio/final-scene/bright-drone.mp3',
				preload: false,
				volume: 0.1,
			}),
			forrestSounds: new Howl({
				src: '../static/audio/final-scene/forrest-sounds.mp3',
				preload: false,
				volume: 0.1,
			}),
		},
	};

	public static getInstance(): AudioPlayer {
		if (!AudioPlayer.instance) {
			AudioPlayer.instance = new AudioPlayer();
		}

		return AudioPlayer.instance;
	}
}
